import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useConvexAuth } from "convex/react";
import { SignInPage } from "@/features/auth/sign-in-page";

// `invite` brings someone back to the invite they opened once they are signed in.
// It carries an invitation id rather than a free URL, so it can't redirect off site.
type Search = { mode?: "create"; invite?: string };

export const Route = createFileRoute("/sign-in")({
  validateSearch: (search: Record<string, unknown>): Search => ({
    ...(search.mode === "create" ? { mode: "create" as const } : {}),
    ...(typeof search.invite === "string" && /^[\w-]+$/.test(search.invite) ? { invite: search.invite } : {}),
  }),
  component: Page,
});

function Page() {
  const { mode, invite } = Route.useSearch();
  const { isAuthenticated } = useConvexAuth();
  if (invite !== undefined && isAuthenticated) {
    return <Navigate to="/invite/$invitationId" params={{ invitationId: invite }} replace />;
  }
  return <SignInPage mode={mode ?? "sign-in"} />;
}
